import React, { useState, useEffect, useCallback } from "react";
import {
  Paper,
  Box,
  IconButton,
  Button,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  InputAdornment,
  TextField,
  Slider,
  CircularProgress,
  Autocomplete,
  Typography,
  Divider,
} from "@mui/material";
import Assetchart from "../Charts/Assetchart";
import CircleIcon from "@mui/icons-material/Circle";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import "../../Styles/strategy.css";
import { useFormik } from "formik";
import { strategyschema } from "../Schemas/strategydetails";
import {
  addStrategies,
  getCustodians,
  getCustodianAssets,
  normalizeCustodianName,
} from "../../Redux/Actions/strategyService";
import { useDispatch, useSelector } from "react-redux";
import customFailAlert from "../../Alerts/customFailAlert";
import { useNavigate } from "react-router-dom";
import customSuccessAlert from "../../Alerts/customSuccessAlert";
import { frequenciesOptions } from "../../Common/Dummy";
import ManagementTiersPopup from "../Popups/ManagementTiersPopup";
import { GetUserInfo } from "../../Redux/Actions/userStatusService";

const benchmarkMapping = {
  "^GSPC": "S&P 500",
  "^IXIC": "NASDAQ",
  "^DJI": "Dow Jones",
  "^RUT": "Russell 2000",
  "EEM": "MSCI Emerging",
  "^FTSE": "FTSE 100",
  "XLK": "Technology Select",
  "BND": "Vanguard Total Bond",
  "GC=F": "Gold Spot Price",
  "CL=F": "Crude Oil (WTI)"
};

  const getAssetColor = (symbol) => {
    const colorMap = {
      BTC: '#9747FF',
      ETH: '#24B47E',
      SOL: '#F3BA2F',
      BNB: '#1E9BF0',
      // Add more as needed
    };
    return colorMap[symbol] || '#F3BA2F'; // Default color
  };

const benchmarkOptions = [
  { name: "S&P 500", symbol: "^GSPC" },
  { name: "NASDAQ", symbol: "^IXIC" },
  { name: "Dow Jones", symbol: "^DJI" },
  { name: "Russell 2000", symbol: "^RUT" },
  { name: "MSCI Emerging", symbol: "EEM" },
  { name: "FTSE 100", symbol: "^FTSE" },
  { name: "Technology Select", symbol: "XLK" },
  { name: "Vanguard Total Bond", symbol: "BND" },
  { name: "Gold Spot Price", symbol: "GC=F" },
  { name: "Crude Oil (WTI)", symbol: "CL=F" }
];

function Deposit() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Custodians, statusCode, custodianAssets } = useSelector(
    (state) => state?.strategy
  );
  const userInfoString = localStorage.getItem("userInfo");
  const userInfo = userInfoString && userInfoString !== "undefined" ? JSON.parse(userInfoString) : null;
  const portal = userInfo?.portal || 'MANAGER';

  const { userInformation } = useSelector((state) => state.userStatus);
  const id = userInformation?.entityInfo?.id;
  const [proportionError, setProportionError] = useState(false);
  const [openTier, setOpenTier] = useState(false);
  const [counter, setCounter] = useState(1);
  const [valueData, setValueData] = useState([]);
  const [managementFeesTier, setmanagementFeesTier] = useState([]);
  const [custData, setCustData] = useState([]);
  const [assetError, setAssetError] = useState("");
  const [tierError, setTierError] = useState("");
  const [assetSelected, setAssetSelected] = useState(false);
  const [cashProportion, setCashProportion] = useState(0);
  const [investmentType, setInvestmentType] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loadingKey, setLoadingKey] = useState(null);
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [hurdleRateApplicable, setHurdleRateApplicable] = useState("No");
  const [hurdleRateType, setHurdleRateType] = useState("");
  const [hurdleRateValue, setHurdleRateValue] = useState("");
  const [benchmark, setBenchmark] = useState("");
  const [hurdleRateError, setHurdleRateError] = useState("");
  const [manageFeeError, setManageFeeError] = useState("");
  const [selectmangError, setselectmangError] = useState("");
  const [perfFeeError, setPerfFeeError] = useState("");
  const [loading, setLoading] = useState(false);
  const [benchmarkComparison, setBenchmarkComparison] = useState("");

  useEffect(() => {
    dispatch(getCustodians());
    dispatch(GetUserInfo(portal));
  }, [dispatch]);
  useEffect(() => {
    if (custodianAssets) setCustData(custodianAssets);
    else setCustData([]);
  }, [custodianAssets]);

  const formik = useFormik({
    initialValues: {
      name: "",
      details: "",
      minvalue: 2,
      risklevel: "low",
      isFlatFee: false,
      custodian: "",
      perfper: 0,
      manageper: 0,
      selectperf: "",
      selectmang: "",
      hurdleRateApplicable: "",
      hurdleRateType: "",
      hurdleRateValue: "",
      benchmark: "",
      assetError: "",
      file: null,
      benchmarkComparison: "",
    },
    validationSchema: strategyschema,
    onSubmit: async (values) => {
      const totalProportions = valueData.reduce(
        (total, asset) => total + asset.proportion,
        cashProportion
      );

      if (values.isFlatFee) {
        if (managementFeesTier.length === 0) {
          alert("Please add values in Management Fees Tier.");
          return;
        }
      } else {
        const manageFeeValue = parseFloat(values.manageper);
        if (!values.manageper) {
          setManageFeeError("Management fee is required");
          return;
        }
        if (isNaN(manageFeeValue) || manageFeeValue < 0) {
          setManageFeeError("Management fee must be 0 or greater");
          return;
        }
        if (values.selectmang == "" || values.selectmang == null) {
          setselectmangError("Select Management Frequency");
          return;
        }
        else {
          setselectmangError("");
        }
      }

      if (!assetSelected) {
        customFailAlert("Please choose proper assets");
        setAssetError("Please select an asset.");
        return;
      } else if (totalProportions !== 100) {
        customFailAlert("Sum of all proportions must be 100%");
        return;
      }
      const breakups = valueData.map(({ assetId, ...rest }) => ({
        proportion: parseFloat(rest.proportion),
        asset: {
          symbol: rest.symbol,
          name: rest.name,
          ...(formik.values.custodian === "IBKR" && rest.conId ? { conId: rest.conId } : {})
        }
      }));

      if (cashProportion > 0) {
        breakups.push({
          proportion: parseFloat(cashProportion),
          asset: {
            symbol: "USD",
            name: "US Dollar"
          }
        });
      }

      const management = managementFeesTier?.map((row) => ({
        limit: parseFloat(row.range.max),
        fee: parseFloat(row.percentage),
      }));

      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("description", values.details);
      let securityType;
      if (formik.values.custodian === "IBKR" || formik.values.custodian === "COINBASE" || formik.values.custodian === "Charles Schwab" || formik.values.custodian === "CHARLES SCHWAB") {
        securityType = investmentType || "CRYPTO";
      } else {
        securityType = "STK"; // Default to STK for other custodians
      }
      formData.append("securityType", securityType);
      formData.append("minInvestment", parseInt(values.minvalue));
      // Always send a custodian value that matches backend enum:
      // COINBASE, INTERACTIVE BROKERS, CHARLES SCHWAB
      const normalizedCustodian = normalizeCustodianName(values.custodian);
      formData.append("custodian", normalizedCustodian);
      formData.append("riskLevel", values.risklevel);
      formData.append("managementFeesFrequency", values.selectmang);
      formData.append("performanceFeesFrequency", values.selectperf);
      
      if (!values.isFlatFee) {
        formData.append(`managementFeesTiers[0][limit]`, 1);
        formData.append(`managementFeesTiers[0][fee]`, parseFloat(values.manageper));
      } else {
        if (managementFeesTier.length === 0) {
          setTierError("Please add at least one management fee tier");
          return;
        }
        
        management.forEach((tier, index) => {
          formData.append(`managementFeesTiers[${index}][limit]`, tier.limit);
          formData.append(`managementFeesTiers[${index}][fee]`, tier.fee);
        });
      }

      formData.append("performanceFeesPercentage", parseFloat(values.perfper));
      if (hurdleRateApplicable === "Yes") {
        formData.append("hurdleRateType", hurdleRateType);
        if (hurdleRateType === "FIXED") {
          formData.append(
            "hurdleRatePercentage",
            parseFloat(hurdleRateValue)
          );
        } else if (hurdleRateType === "BENCHMARK") {
          formData.append("performanceBenchmark[name]", benchmarkMapping[benchmark]);
          formData.append("performanceBenchmark[symbol]", benchmark);
        }
      }

      breakups.forEach((breakup, index) => {
        formData.append(`breakups[${index}][proportion]`, breakup.proportion);
        formData.append(`breakups[${index}][asset][symbol]`, breakup.asset.symbol);
        formData.append(`breakups[${index}][asset][name]`, breakup.asset.name);
        
        if (formik.values.custodian === "IBKR" && breakup.asset.symbol !== "USD" && breakup.asset.conId) {
          formData.append(`breakups[${index}][asset][conId]`, breakup.asset.conId);
        }
      });

      if (selectedFile) {
        formData.append("media", selectedFile);
      }

      if (benchmarkComparison) {
        const benchmarkName = {
          "^GSPC": "S&P 500",
          "^IXIC": "NASDAQ",
          "^DJI": "Dow Jones",
          "^RUT": "Russell 2000",
          "EEM": "MSCI Emerging",
          "^FTSE": "FTSE 100",
          "XLK": "Technology Select",
          "BND": "Vanguard Total Bond",
          "GC=F": "Gold Spot Price",
          "CL=F": "Crude Oil (WTI)"
        }[benchmarkComparison];

        formData.append("benchmarkComparison[name]", benchmarkName);
        formData.append("benchmarkComparison[symbol]", benchmarkComparison);
      }

      setLoading(true);

      await dispatch(addStrategies({ body: formData, id: id, role: portal }))
        .then((response) => {
          if (response?.payload.statusCode === 201) {
            customSuccessAlert("Strategy Added Successfully.");
            navigate("/strategy");
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false);
          setLoadingKey(null);
        });
    },
  });

  const handleProportionChange = (symbol, newValue) => {
    const updatedValueData = valueData.map((item) =>
      item.symbol === symbol ? { ...item, proportion: newValue } : item
    );

    const totalProportions = updatedValueData.reduce(
      (total, asset) => total + asset.proportion,
      0
    );

    setValueData(updatedValueData);
    setAssetSelected(true);

    // Check if total equals 100
    const total = totalProportions + cashProportion;
    if (total !== 100) {
      setProportionError(true);
    } else {
      setProportionError(false);
    }
  };

  const handleCashProportionChange = (event, newValue) => {
    setCashProportion(newValue);

    // Calculate total of all asset proportions
    const totalProportions = valueData.reduce(
      (total, asset) => total + asset.proportion,
      0
    );

    // Check if total equals 100
    const total = totalProportions + newValue;
    if (total !== 100) {
      setProportionError(true);
    } else {
      setProportionError(false);
    }
  };

  function valuetext(value) {
    return `${value}`;
  }

  const resetFunction = () => {
    setValueData([]);
    setCashProportion(0);
    setCounter(0);
    setProportionError(false);
  };

  const AddList = () => {
    // Add new asset with 0 proportion - user will set manually
    const updatedValueData = [...valueData, { proportion: 0 }];

    setValueData(updatedValueData);
    setCounter((prevCounter) => prevCounter + 1);
    setProportionError(true); // Set error since total won't be 100 with new 0% asset
  };

  const handleRemoveAsset = (key) => {
    const updatedValueData = valueData.filter((item, index) => index !== key);
    
    setValueData(updatedValueData);

    // Recalculate total after removal
    const totalProportions = updatedValueData.reduce(
      (total, asset) => total + asset.proportion,
      0
    );
    const total = totalProportions + cashProportion;
    if (total !== 100) {
      setProportionError(true);
    } else {
      setProportionError(false);
    }

    if (counter > 0) {
      setCounter(counter - 1);
    }
  };

  const handleSearchChange = useCallback(
    (event, value, key) => {
      if (value) {
        setLoadingKey(key);
        if (searchTimeout) clearTimeout(searchTimeout);
        setSearchTimeout(
          setTimeout(() => {
            let currentInvestmentType;
            if (formik.values.custodian === "IBKR" || formik.values.custodian === "COINBASE" || formik.values.custodian === "Charles Schwab" || formik.values.custodian === "CHARLES SCHWAB") {
              currentInvestmentType = investmentType || "CRYPTO";
            } else {
              currentInvestmentType = "STK"; // Default to STK for other custodians
            }
            dispatch(
              getCustodianAssets({
                custodian: formik.values.custodian,
                query: value,
                investmentType: currentInvestmentType,
                exchange: "NASDAQ",
              })
            )
              .then((response) => {
                if (response?.payload.statusCode === 200) {
                  setSearchResults(response?.payload.data);
                }
              })
              .catch((error) => {
                console.error(error);
              })
              .finally(() => {
                setLoadingKey(null); // Reset the loading key after completion
              });
          }, 500)
        );
      }
    },
    [dispatch, investmentType, formik.values.custodian, searchTimeout]
  );

  const handleAssetSelect = (event, newValue, key) => {
    if (newValue) {
      const updatedValueData = valueData.map((item, index) =>
        index === key
          ? {
              ...item,
              symbol: newValue.symbol,
              name: newValue.name,
              conId: newValue.conId,
              exchange: "NASDAQ",
            }
          : item
      );
      setValueData(updatedValueData);
      setAssetSelected(true);
    }
  };

  const handleInvestmentTypeChange = (e) => {
    setInvestmentType(e.target.value);
    setValueData([]);
    setCounter(0);
    setCashProportion(0);
    setProportionError(false);
  };

  const isDisabled = () => {
    if (!formik.values.custodian) return true;
    // For IBKR, Coinbase, and Charles Schwab, investment type must be selected
    if (formik.values.custodian === "IBKR" || formik.values.custodian === "COINBASE" || formik.values.custodian === "Charles Schwab" || formik.values.custodian === "CHARLES SCHWAB") {
      if (!investmentType) return true;
    }
    return false;
  };

  const isAssetSectionDisabled = () => {
    return isDisabled();
  };

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
      const validFileTypes = ["video/mp4", "video/x-matroska"];
      if (validFileTypes.includes(file.type)) {
        setSelectedFile(file);
        formik.setFieldValue("file", file);
      } else {
        customFailAlert("Only .mp4 and .mkv file formats are allowed.");
        setSelectedFile(null);
        formik.setFieldValue("file", null);
      }
    }
  };

  const handleHurdleRateApplicableChange = (event) => {
    setHurdleRateApplicable(event.target.value);
    setHurdleRateType("");
    setHurdleRateValue("");
    setBenchmark("");
  };

  const handleHurdleRateTypeChange = (event) => {
    setHurdleRateType(event.target.value);
    setHurdleRateValue("");
  };

  const handleHurdleRateValueChange = (value) => {
    const numericValue = parseFloat(value);
    if (isNaN(numericValue) || numericValue < 0) {
      setHurdleRateError("Hurdle Rate must be 0 or greater.");
      setHurdleRateValue("");
      return;
    }
    setHurdleRateError("");
    setHurdleRateValue(numericValue);
  };

  const handleManageFeeChange = (value) => {
    if (value === "") {
      formik.setFieldValue("manageper", value);
      setManageFeeError("Management Fee is required.");
      return;
    }
    if (value === "." || value === "0.") {
      formik.setFieldValue("manageper", value);
      setManageFeeError("");
      return;
    }
    
    // Check if it's a valid number format (allows decimals)
    const numericValue = parseFloat(value);
    if (isNaN(numericValue) || numericValue < 0) {
      setManageFeeError("Management Fee must be 0 or greater.");
      // Still allow the value to be set so user can continue typing
      formik.setFieldValue("manageper", value);
      return;
    }
    setManageFeeError("");
    formik.setFieldValue("manageper", value); // Store as string to preserve decimals
  };

  const handlePerfFeeChange = (value) => {
    // Allow empty string and preserve decimal point while typing
    if (value === "" || value === "." || value === "0.") {
      formik.setFieldValue("perfper", value);
      setPerfFeeError("");
      return;
    }
    
    // Check if it's a valid number format (allows decimals)
    const numericValue = parseFloat(value);
    if (isNaN(numericValue) || numericValue < 0) {
      setPerfFeeError("Performance Fee must be 0 or greater.");
      // Still allow the value to be set so user can continue typing
      formik.setFieldValue("perfper", value);
      return;
    }
    setPerfFeeError("");
    formik.setFieldValue("perfper", value); // Store as string to preserve decimals
  };

  return (
    <>
      <div className="row">
        <div className="col-6" style={{ marginLeft: "-10px" }}>
          <Paper className="strategy-paper">
            {/* Header */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3}}>
              <Typography 
                variant="h6" 
                sx={{ 
                  
                  fontWeight: 500,
                  fontStyle: 'Medium',
                  fontSize: '24px',
                  lineHeight: '32px',
                  letterSpacing: '0%'
                }}
              >
                Strategy Details
              </Typography>
            </Box>
            <hr />
            <Box sx={{ width: "100%", typography: "body1" }}>
              <>
                <form style={{ margin: "40px" }} onSubmit={formik.handleSubmit}>
                  <div className="row mb-1">
                    <label
                      htmlFor="custodian"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Select Custodian
                    </label>
                    <div className="col-sm-7">
                      <div className="form-group">
                        <select
                          className="form-control"
                          id="custodian"
                          placeholder="Choose custodians"
                          value={formik.values.custodian || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            if (selectedValue === "") {
                              formik.setFieldValue("custodian", "");
                              setCustData([]);
                              setValueData([]);
                              setProportionError(false);
                              setInvestmentType("");
                              setCounter(0);
                              setCashProportion(0);
                            } else {
                              formik.setFieldValue("custodian", selectedValue);
                              // Reset asset data when changing custodian
                              setValueData([]);
                              setCounter(0);
                              setCashProportion(0);
                              setProportionError(false);
                              // Auto-select investment type based on custodian
                              if (selectedValue === "COINBASE") {
                                setInvestmentType("CRYPTO");
                              } else if (selectedValue === "IBKR" || selectedValue === "Charles Schwab" || selectedValue === "CHARLES SCHWAB") {
                                setInvestmentType("STK");
                              } else {
                                setInvestmentType("");
                              }
                            }
                            formik.handleChange(e);
                          }}
                          onBlur={formik.handleBlur}
                        >
                          <option value="">Select Custodian</option>
                          {Custodians?.map((i) => {
                            return (
                              <option key={i?.name} value={i?.name}>
                                {i?.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {formik.errors.custodian && formik.touched.custodian ? (
                        <p
                          className="form-error"
                          style={{ color: "red", fontSize: "11px" }}
                        >
                          {formik.errors.custodian}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  {(formik.values.custodian === "IBKR" || formik.values.custodian === "COINBASE" || formik.values.custodian === "Charles Schwab" || formik.values.custodian === "CHARLES SCHWAB") && (
                    <>
                      <div className="row mb-1">
                        <label
                          htmlFor="investmentType"
                          className="col-sm-5 col-form-label"
                          style={{ fontWeight: "bold" }}
                        >
                          Select Investment Type
                        </label>
                        <div className="col-sm-7">
                          <RadioGroup
                            row
                            aria-labelledby="investment-type-label"
                            name="investmentType"
                            value={investmentType}
                            onChange={handleInvestmentTypeChange}
                          >
                            <FormControlLabel
                              value="CRYPTO"
                              control={<Radio />}
                              label="Crypto"
                              disabled={formik.values.custodian === "IBKR" || formik.values.custodian === "Charles Schwab" || formik.values.custodian === "CHARLES SCHWAB"}
                            />
                            <FormControlLabel
                              value="STK"
                              control={<Radio />}
                              label="Stock"
                              disabled={formik.values.custodian === "COINBASE"}
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="row mb-3">
                    <label
                      htmlFor="name"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Name
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        disabled={isDisabled()}
                      />
                      {formik.errors.name && formik.touched.name ? (
                        <p
                          className="form-error"
                          style={{ color: "red", fontSize: "11px" }}
                        >
                          {formik.errors.name}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label
                      htmlFor="minvalue"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Minimum Value
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="number"
                        className="form-control"
                        name="minvalue"
                        value={formik.values.minvalue}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        disabled={isDisabled()}
                      />
                      {formik.errors.minvalue && formik.touched.minvalue ? (
                        <p
                          className="form-error"
                          style={{ color: "red", fontSize: "11px" }}
                        >
                          {formik.errors.minvalue}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="row mb-3">
                    <label
                      htmlFor="details"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Aim & Objectives
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        name="details"
                        value={formik.values.details}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        disabled={isDisabled()}
                      />
                      {formik.errors.details && formik.touched.details ? (
                        <p
                          className="form-error"
                          style={{ color: "red", fontSize: "11px" }}
                        >
                          {formik.errors.details}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label
                      htmlFor="file"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Upload a File
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="file"
                        className="form-control"
                        name="file"
                        accept=".mp4,.mkv"
                        onChange={handleFileChange}
                        onBlur={formik.handleBlur}
                        disabled={isDisabled()}
                      />
                      {formik.errors.file && formik.touched.file ? (
                        <p
                          className="form-error"
                          style={{ color: "red", fontSize: "11px" }}
                        >
                          {formik.errors.file}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label
                      htmlFor="risklevel"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Risk Level
                    </label>
                    <div className="col-sm-7 d-flex align-items-center">
                      <FormControl
                        component="fieldset"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="risklevel"
                          value={formik.values.risklevel}
                          onChange={(e) =>
                            formik.setFieldValue("risklevel", e.target.value)
                          }
                        >
                          <FormControlLabel
                            value="LOW"
                            control={<Radio />}
                            label="Low"
                            sx={{ marginRight: "20px" }}
                            disabled={isDisabled()}
                          />
                          <FormControlLabel
                            value="MEDIUM"
                            control={<Radio />}
                            label="Medium"
                            sx={{ marginRight: "20px" }}
                            disabled={isDisabled()}
                          />
                          <FormControlLabel
                            value="HIGH"
                            control={<Radio />}
                            label="High"
                            disabled={isDisabled()}
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <label
                      htmlFor="risklevel"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Managment Tiers
                    </label>
                    <div className="col-sm-7 d-flex align-items-center">
                      <FormControl
                        component="fieldset"
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="isFlatFee"
                          value={formik.values.isFlatFee}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "isFlatFee",
                              e.target.value === "true"
                            )
                          }
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Yes"
                            sx={{ marginRight: "20px" }}
                            disabled={isDisabled()}
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="No"
                            sx={{ marginRight: "20px" }}
                            disabled={isDisabled()}
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                  {formik.values?.isFlatFee ? (
                    <>
    <div className="row mb-1">
      <label
        htmlFor="management"
        className="col-sm-5 col-form-label"
        style={{ fontWeight: "bold" }}
      >
        Management Fees Frequency
      </label>
      <div className="col-sm-7">
        <div className="form-group">
          <select
            className="form-control"
            id="management"
            placeholder="Choose Frequency"
            value={formik.values.selectmang || ""}
            onChange={(e) => {
              const selectedValue = e.target.value;
              formik.setFieldValue("selectmang", selectedValue);
              if (selectedValue === "") {
                setProportionError("");
              }
              formik.handleChange(e);
            }}
            onBlur={formik.handleBlur}
            // style={{ width: "299px" }}
            disabled={isDisabled()}
          >
            <option value="">Select Frequency</option>
            {frequenciesOptions?.map((i) => (
              <option key={i} value={i}>
                {i}
              </option>
            ))}
          </select>
        </div>
        {formik.errors.selectmang && formik.touched.selectmang ? ( // Display error message if validation fails
          <p className="form-error" style={{ color: "red", fontSize: "11px" }}>
            {formik.errors.selectmang}
          </p>
        ) : null}
      </div>
    </div>
  
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        variant="contained"
                        sx={{ mb: 1 }}
                        onClick={() => {
                          setOpenTier(true);
                        }}
                      >
                        Add Tiers
                      </Button>
                    </div>
                    </>
                  ) : (
                    <div className="row mb-1">
                    <label
                      htmlFor="management"
                      className="col-lg-5 col-md-5 col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Management Fees
                    </label>
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      <div className="form-group">
                        <select
                          className="form-control"
                          id="management"
                          placeholder="Choose Frequency"
                          value={formik.values.selectmang || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            if (selectedValue === "") {
                              formik.setFieldValue("selectmang", "");
                              setProportionError("");
                            } else {
                              formik.setFieldValue("selectmang", selectedValue);
                            }
                            formik.handleChange(e);
                          }}
                          onBlur={formik.handleBlur}
                          style={{ width: "150px" }}
                          disabled={isDisabled()}
                        >
                          <option value="">Select Frequency</option>
                          {frequenciesOptions?.map((i) => {
                            return (
                              <option key={i} value={i}>
                                {i}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {selectmangError ? (
                        <p
                          className="form-error"
                          style={{ color: "red", fontSize: "11px" }}
                        >
                          {selectmangError}
                        </p>
                      ) : null}
                    </div>
                    <div className="col-sm-2">
                      <TextField
                        type="number"
                        name="manageper"
                        value={formik.values.manageper !== undefined && formik.values.manageper !== null ? String(formik.values.manageper) : ""}
                        onChange={(e) => handleManageFeeChange(e.target.value)}
                        onBlur={formik.handleBlur}
                        className="form-control no-spinners"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end"><span style={{fontWeight: 'bold'}}>%</span></InputAdornment>
                          ),
                        }}
                        inputProps={{
                          min: 0,
                          step: "any"
                        }}
                        sx={{
                          height: "40px",
                          width: "90px",
                          ".MuiInputBase-input": {
                            height: "40px",
                            padding: "0 14px",
                          },
                        }}
                        disabled={isDisabled()}
                      />
                      {manageFeeError && (
                        <p style={{ color: "red", fontSize: "11px" }}>
                          {manageFeeError}
                        </p>
                      )}
                    </div>
                  </div>
                  )}

                  <div className="row mb-1">
                    <label
                      htmlFor="benchmarkComparison"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Benchmark Comparison
                    </label>
                    <div className="col-sm-7 col-lg-7 col-md-7">
                      <div className="form-group">
                        <select
                          className="form-control"
                          id="benchmarkComparison"
                          value={benchmarkComparison}
                          onChange={(e) => setBenchmarkComparison(e.target.value)}
                          disabled={isDisabled()}
                        >
                          <option value="">Select Benchmark</option>
                          <option value="^GSPC">S&P 500</option>
                          <option value="^IXIC">NASDAQ</option>
                          <option value="^DJI">Dow Jones</option>
                          <option value="^RUT">Russell 2000</option>
                          <option value="EEM">MSCI Emerging</option>
                          <option value="^FTSE">FTSE 100</option>
                          <option value="XLK">Technology Select</option>
                          <option value="BND">Vanguard Total Bond</option>
                          <option value="GC=F">Gold Spot Price</option>
                          <option value="CL=F">Crude Oil (WTI)</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row mb-1">
                    <label
                      htmlFor="performance"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Performance Fees
                    </label>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <select
                          className="form-control"
                          id="performance"
                          placeholder="Choose performance"
                          value={formik.values.selectperf || ""}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            if (selectedValue === "") {
                              formik.setFieldValue("selectperf", "");
                              setProportionError("");
                            } else {
                              formik.setFieldValue("selectperf", selectedValue);
                            }
                            formik.handleChange(e);
                          }}
                          onBlur={formik.handleBlur}
                          style={{ width: "150px" }}
                          disabled={isDisabled()}
                        >
                          <option value="">Select Frequency</option>
                          {frequenciesOptions?.map((i) => {
                            return (
                              <option key={i} value={i}>
                                {i}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {formik.errors.selectperf && formik.touched.selectperf ? (
                        <p
                          className="form-error"
                          style={{ color: "red", fontSize: "11px" }}
                        >
                          {formik.errors.selectperf}
                        </p>
                      ) : null}
                    </div>
                    <div className="col-sm-2">
                      <TextField
                        type="number"
                        name="perfper"
                        value={formik.values.perfper !== undefined && formik.values.perfper !== null ? String(formik.values.perfper) : ""}
                        onChange={(e) => handlePerfFeeChange(e.target.value)}
                        onBlur={formik.handleBlur}
                        className="form-control"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end"><span style={{fontWeight: 'bold'}}>%</span></InputAdornment>
                          ),
                        }}
                        inputProps={{
                          min: 0,
                          step: "any"
                        }}
                        sx={{
                          height: "40px",
                          width: "90px",
                          ".MuiInputBase-input": {
                            height: "40px",
                            padding: "0 14px",
                          },
                        }}
                        disabled={isDisabled()}
                      />
                      {perfFeeError && ( // Display error message for performance fee
                        <p style={{ color: "red", fontSize: "11px" }}>
                          {perfFeeError}
                        </p>
                      )}
                    </div>
                  </div>
                  {/* Hurdle Rate Section */}
                  <div className="row mb-3">
                    <label
                      htmlFor="hurdleRateApplicable"
                      className="col-sm-5 col-form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      Hurdle Rate Applicable
                    </label>
                    <div className="col-sm-7">
                      <select
                        className="form-control"
                        value={hurdleRateApplicable}
                        onChange={handleHurdleRateApplicableChange}
                        disabled={isDisabled()}
                      >
                        <option value="No">No</option>
                        <option value="Yes">Yes</option>
                      </select>
                    </div>
                  </div>

                  {hurdleRateApplicable === "Yes" && (
                    <>
                      <div className="row mb-3">
                        <label
                          htmlFor="hurdleRateType"
                          className="col-sm-5 col-form-label"
                          style={{ fontWeight: "bold" }}
                        >
                          Hurdle Rate Type
                        </label>
                        <div className="col-sm-7">
                          <select
                            className="form-control"
                            value={hurdleRateType}
                            onChange={handleHurdleRateTypeChange}
                            disabled={isDisabled()}
                          >
                            <option value="">Select Type</option>
                            <option value="FIXED">Fixed</option>
                            <option value="BENCHMARK">Benchmark</option>
                          </select>
                          {formik.errors.hurdleRateType &&
                            formik.touched.hurdleRateType && (
                              <p style={{ color: "red", fontSize: "11px" }}>
                                {formik.errors.hurdleRateType}
                              </p>
                            )}
                        </div>
                      </div>

                      {hurdleRateType === "FIXED" && (
                        <div className="row mb-3">
                          <label
                            htmlFor="hurdleRateValue"
                            className="col-sm-5 col-form-label"
                            style={{ fontWeight: "bold" }}
                          >
                            Hurdle Rate
                          </label>
                          <div className="col-sm-7">
                            <TextField
                              type="number"
                              className="form-control"
                              value={hurdleRateValue}
                              onChange={(e) =>
                                handleHurdleRateValueChange(e.target.value)
                              }
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <span style={{fontWeight: 'bold'}}>%</span>
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{
                                min: 0,
                                step: "any"
                              }}
                              disabled={isDisabled()}
                              sx={{
                                height: "40px",
                                ".MuiInputBase-input": {
                                  height: "40px",
                                  padding: "0 14px",
                                },
                              }}
                            />
                            {hurdleRateError && ( // Display error message for hurdle rate
                              <p style={{ color: "red", fontSize: "11px" }}>
                                {hurdleRateError}
                              </p>
                            )}
                          </div>
                        </div>
                      )}

                      {hurdleRateType === "BENCHMARK" && (
                        <div className="row mb-3">
                          <label
                            htmlFor="benchmark"
                            className="col-sm-5 col-form-label"
                            style={{ fontWeight: "bold" }}
                          >
                            Select Benchmark
                          </label>
                          <div className="col-sm-7">
                            <select
                              className="form-control"
                              value={benchmark}
                              onChange={(e) => setBenchmark(e.target.value)}
                              disabled={isDisabled()}
                            >
                              <option value="">Select Benchmark</option>
                              <option value="^GSPC">S&P 500</option>
                              <option value="^IXIC">NASDAQ</option>
                              <option value="^DJI">Dow Jones</option>
                              <option value="^RUT">Russell 2000</option>
                              <option value="EEM">MSCI Emerging</option>
                              <option value="^FTSE">FTSE 100</option>
                              <option value="XLK">Technology Select</option>
                              <option value="BND">Vanguard Total Bond</option>
                              <option value="GC=F">Gold Spot Price</option>
                              <option value="CL=F">Crude Oil (WTI)</option>
                            </select>
                            {formik.errors.benchmark &&
                              formik.touched.benchmark && (
                                <p style={{ color: "red", fontSize: "11px" }}>
                                  {formik.errors.benchmark}
                                </p>
                              )}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  <div
                    className="row"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "10px",
                    }}
                  >
                    <Button
                      type="button"
                      variant="contained"
                      sx={{ 
                        mb: 1, 
                        mr: 2, 
                        pt: 1, 
                        pb: 1,
                        backgroundColor: '#1976d2',
                        color: 'white',
                        borderRadius: '8px',
                        border: 'none',
                        padding: '12px 24px',
                        fontSize: '14px',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        '&:hover': {
                          backgroundColor: '#1565c0',
                          boxShadow: '0 6px 12px rgba(0, 0, 0, 0.25)',
                        },
                        '&:disabled': {
                          backgroundColor: '#ccc',
                          color: '#666',
                          boxShadow: 'none',
                        }
                      }}
                      disabled={isDisabled()}
                      onClick={formik.handleSubmit}
                    >
                      SAVE STRATEGY
                    </Button>
                  </div>
                </form>
                <br />
              </>
            </Box>
          </Paper>
        </div>

        <div className="col-6">
          <Paper className="strategy-paper">
            {/* Header */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3}}>
              <Typography 
                variant="h6" 
                sx={{ 
                 
                  fontWeight: 500,
                  fontStyle: 'Medium',
                  fontSize: '24px',
                  lineHeight: '32px',
                  letterSpacing: '0%'
                }}
              >
                Asset Allocation
              </Typography>
              <Button
                className="reset-changes-button"
                onClick={resetFunction}
                disabled={isAssetSectionDisabled()}
              >
                Reset Changes
              </Button>
            </Box>

            {/* Chart */}
            <Box sx={{ width: "100%", mb: 4 }}>
              <Assetchart 
                data={[
                  ...valueData,
                  ...(cashProportion > 0 ? [{
                    asset: { name: "USD Cash", symbol: "USD" },
                    proportion: cashProportion
                  }] : [])
                ]} 
              />
            </Box>

            {/* Asset List */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {/* USD/Cash Row */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <CircleIcon sx={{ color: '#F3BA2F', fontSize: 36 }} />
                <Box sx={{ width: '90px', display: 'flex', flexDirection: 'column' }}>
                  <Typography className="asset-label-text">Cash</Typography>
                  <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>(USD)</Typography>
                </Box>
                <TextField
                  value={cashProportion}
                  disabled
                  size="small"
                  InputProps={{
                    endAdornment: <InputAdornment position="end" sx={{color: '#323232' }}>%</InputAdornment>,
                    sx: { 
                      fontSize: '0.875rem',
                      '& .MuiOutlinedInput-input': { padding: '6px 8px' },
                      width: '90px',
                      backgroundColor: '#f5f5f5',
                      '& .Mui-disabled': {
                        WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                      }
                    }
                  }}
                />
                <Slider
                  value={cashProportion}
                  onChange={(e, newValue) => handleCashProportionChange(e, newValue)}
                  disabled={isAssetSectionDisabled()}
                  sx={{ 
                    flex: 1,
                    '& .MuiSlider-rail': { backgroundColor: '#E0E0E0' },
                    '& .MuiSlider-track': { backgroundColor: '#1976d2' },
                    '& .MuiSlider-thumb': {
                      width: 12,
                      height: 12,
                      backgroundColor: '#fff',
                      border: '2px solid #1976d2',
                      '&:hover, &.Mui-focusVisible': {
                        boxShadow: 'none'
                      }
                    }
                  }}
                />
                <TextField
                  value={cashProportion}
                  onChange={(e) => {
                    const value = parseInt(e.target.value) || 0;
                    handleCashProportionChange(e, value);
                  }}
                  size="small"
                  InputProps={{
                    endAdornment: <InputAdornment position="end" sx={{color: '#323232' }}><span style={{fontWeight: 'bold'}}>%</span></InputAdornment>,
                    sx: { 
                      fontSize: '0.875rem',
                      '& .MuiOutlinedInput-input': { padding: '6px 8px' },
                      width: '90px'
                    }
                  }}
                />
                <Box sx={{ width: 25 }} /> {/* Maintain alignment */}
              </Box>

              <Divider/>

              {/* Other Assets */}
              {valueData.map((value, key) => (
                <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <CircleIcon sx={{ color: getAssetColor(value.symbol), fontSize: 36 }} />
                  <Typography className="asset-label-text" sx={{ width: '90px' }}>
                    {value.symbol || (
                      <Autocomplete
                        options={searchResults}
                        getOptionLabel={(option) => option.symbol}
                        loading={loadingKey === key}
                        onInputChange={(event, newInputValue) => handleSearchChange(event, newInputValue, key)}
                        onChange={(event, newValue) => handleAssetSelect(event, newValue, key)}
                        disabled={isAssetSectionDisabled()}
                        renderInput={(params) => (
                          <TextField 
                            {...params} 
                            label="Asset" 
                            sx={{ width: '100px' }}
                            disabled={isAssetSectionDisabled()}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loadingKey === key ? <CircularProgress size={20} /> : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    )}
                  </Typography>
                  {value.symbol && (
                    <TextField
                      value={value.proportion}
                      disabled
                      size="small"
                      InputProps={{
                        endAdornment: <InputAdornment position="end" sx={{color: '#323232' }}>%</InputAdornment>,
                        sx: { 
                          fontSize: '0.875rem',
                          '& .MuiOutlinedInput-input': { padding: '6px 8px' },
                          width: '90px',
                          backgroundColor: '#f5f5f5',
                          '& .Mui-disabled': {
                            WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
                          }
                        }
                      }}
                    />
                  )}
                  <Slider
                    value={value.proportion}
                    onChange={(e, newValue) => handleProportionChange(value.symbol, newValue)}
                    disabled={isAssetSectionDisabled()}
                    sx={{ 
                      flex: 1,
                      '& .MuiSlider-rail': { backgroundColor: '#E0E0E0' },
                      '& .MuiSlider-track': { backgroundColor: '#1976d2' },
                      '& .MuiSlider-thumb': {
                        width: 12,
                        height: 12,
                        backgroundColor: '#fff',
                        border: '2px solid #1976d2',
                        '&:hover, &.Mui-focusVisible': {
                          boxShadow: 'none'
                        }
                      }
                    }}
                  />
                  <TextField
                    value={value.proportion}
                    onChange={(e) => {
                      const inputValue = parseInt(e.target.value) || 0;
                      handleProportionChange(value.symbol, inputValue);
                    }}
                    size="small"
                    InputProps={{
                      endAdornment: <InputAdornment position="end" sx={{color: '#323232', fontFamily:'inherit' }}><span style={{fontWeight: 'bold'}}>%</span></InputAdornment>,
                      sx: { 
                        fontSize: '0.875rem',
                        '& .MuiOutlinedInput-input': { padding: '6px 8px' },
                        width: '90px'
                      }
                    }}
                  />
                  <IconButton 
                    size="small"
                    onClick={() => handleRemoveAsset(key)}
                    disabled={isAssetSectionDisabled()}
                    sx={{ 
                      padding: 0.5,
                      '&:hover': { backgroundColor: 'transparent' }
                    }}
                  >
                    <DeleteOutlineIcon sx={{ 
                      fontSize: 18, 
                      color: '#323232',
                      strokeWidth: 1.5,
                      '& path': {
                        strokeWidth: 1.5
                      }
                    }} />
                  </IconButton>
                </Box>
              ))}
            </Box>

            {/* Add Asset Button */}
            <Button
              sx={{ 
                mt: 3,
                width: 132,
                gap: 8,
                border: '2px solid #1976d2',
                color: '#1976d2',
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 'bold',
                fontSize: '1rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover': {
                  backgroundColor: '#1976d2',
                  color: '#fff',
                },
                '&:disabled': {
                  border: '2px solid #ccc',
                  color: '#999',
                  backgroundColor: 'transparent',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    color: '#999',
                  }
                }
              }}
              onClick={AddList}
              disabled={isAssetSectionDisabled()}
            >
              + Add Asset
            </Button>

            {proportionError && (
              <Typography color="error" sx={{ mt: 2, fontSize: '0.875rem' }}>
                Sum of all proportions must be 100%. Current total: {valueData.reduce((total, asset) => total + asset.proportion, cashProportion)}%
              </Typography>
            )}
          </Paper>
        </div>
      </div>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <ManagementTiersPopup
        open={openTier}
        onClose={() => setOpenTier(false)}
        managementFeesTier={managementFeesTier}
        setmanagementFeesTier={setmanagementFeesTier}
      />
    </>
  );
}

export default Deposit;
